// 수행평가
import Resource from './Resource'

export default class Plan extends Resource {
  static ENDPOINT = '/api/plan'

  constructor (args) {
    super()
    this.extend(args)
  }

  static create (subject) {
    const plan = {
      subject,
      objective: '',
      book: '',
      lectureMethods: [],
      evalMethods: [],
      evalratio: [],
      facilities: [],
      devices: []
    }
    return new Plan(plan)
  }
}
